export var ValueSourceCertainty;
(function (ValueSourceCertainty) {
    ValueSourceCertainty[ValueSourceCertainty["Unreliable"] = 0] = "Unreliable";
    ValueSourceCertainty[ValueSourceCertainty["Questionable"] = 1] = "Questionable";
    ValueSourceCertainty[ValueSourceCertainty["Secondary"] = 2] = "Secondary";
    ValueSourceCertainty[ValueSourceCertainty["Primary"] = 3] = "Primary";
})(ValueSourceCertainty || (ValueSourceCertainty = {}));
//# sourceMappingURL=ValueSourceCertainty.js.map